module.exports = __webpack_public_path__ + "static/media/bookmark.a43049ec.svg";